import { render, staticRenderFns } from "./SlsE_Details.vue?vue&type=template&id=57d28b8d"
import script from "./SlsE_Details.vue?vue&type=script&lang=js"
export * from "./SlsE_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports